import React from 'react';
import { TasticWrapperProps } from './types';
import { deviceVisibility } from '../../utils/device-visibility';
import { highlight } from '../../utils/highlight';
import { injectDataSources } from '../../utils/inject-datasources';
import TasticErrorBoundary from './error-boundary';
import SeoContentRenderer from './SeoContentRenderer';
import { getAmplienceContentByDeliveryKey } from 'helpers/utils/getAmplienceContentByDeliveryKey';
import { cache } from 'react';

// Request-scoped SEO tracking
const getSeoState = cache(() => ({ rendered: false }));

const getCleanAmplienceData = (result: any) => {
  if (result?.fullContent && !result.fullContent.error) return result.fullContent;
  if (result?.brandContent && !result.brandContent.error) return result.brandContent;
  return result;
};

const TasticWrapper = async ({
  tastics,
  data,
  params,
  searchParams,
  dataSources,
  isHighlighted,
  categories,
  algoliaData,
  serverCurrency,
  seoStructureData,
}: TasticWrapperProps) => {
  const Tastic = tastics[data.tasticType];
  if (!Tastic) return null;

  const currentUrl = categories?.[0]?.slug;
  let amplienceData = null;

  if (currentUrl) {
    try {
      amplienceData = getCleanAmplienceData(await getAmplienceContentByDeliveryKey(currentUrl));
    } catch (error) {
      console.error('Amplience fetch failed:', error);
    }
  }

  const resolvedTasticData = dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration;

  // Get SEO state for this request
  const seoState = getSeoState();
  const shouldRenderSeo = amplienceData && !seoState.rendered;

  // Update state immediately if rendering SEO
  if (shouldRenderSeo) {
    seoState.rendered = true;
  }

  return (
    <>
      <div className={`${highlight(isHighlighted)} ${deviceVisibility(data.configuration)}`}>
        <TasticErrorBoundary tasticType={data.tasticType}>
          {shouldRenderSeo && <SeoContentRenderer content={amplienceData} />}
          <Tastic
            data={resolvedTasticData}
            params={params}
            searchParams={searchParams}
            categories={categories}
            algoliaData={algoliaData}
            serverCurrency={serverCurrency}
            seoStructureData={seoStructureData}
            amplienceData={amplienceData}
          />
        </TasticErrorBoundary>
      </div>
    </>
  );
};

export default TasticWrapper;
